module.exports = __webpack_public_path__ + "static/media/archive-replay@2x.3bf68c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/archive-replay@2x.png
// module id = 929
// module chunks = 0